module.exports = __webpack_public_path__ + "img/401.01e7b186.svg";